import Collapsible from "app/components/Collapsible/Collapsible";
import { betPanelHelper } from "app/helpers/betPanelHelper";
import BetDrawerLogic from "app/logic/betDrawerLogic";
import type { BetSlipType } from "app/types/betSlipType";
import { REGEX_VS } from "app/utils/const";
import words from "lodash/words";
import { Component } from "react";
import { connect } from "react-redux";
import BetSlip from "../BetSlip/BetSlip";
type Props = {
  history: any;
  betSlipList: BetSlipType[];
  updateBetSlip: (...args: Array<any>) => any;
  isIdle: boolean;
  betslipFull: boolean;
  updateCollapsedBetSlipsCount: Function;
  updateBetSlipGroupedEvents: Function;
  toggleNumberOfBetSlipGroupedEvents: Function;
};

class BetSlipEvent extends Component<Props> {
  renderTeamName = (teamName: string) => {
    return (
      <div className="bet-slip__header__team-name">
        <span>{teamName}</span>
      </div>
    );
  };
  toggleCollapsible = () => {
    // Use isActive in betSlips for opening/closing Event collapsible
    const { betSlipList } = this.props;
    BetDrawerLogic.toggleBetSlipGroup(betSlipList[0].id);
    betSlipList.forEach((betSlip, list) => {
      betSlip.isActive = !betSlip.isActive;
      this.props.updateBetSlip(betSlip);
    });
    betPanelHelper.countExpandedCollapsedBetSlips();
  };

  getBetSlipContent = betSlipList => {
    // Get the " vs " or " at " from the event name
    const { betslipFull } = this.props;
    let teamVS = words(betSlipList[0].translatedName, REGEX_VS);
    // Get the two team names (without the "vs" or "at")
    let teamNames: any =
      betSlipList[0].translatedName !== undefined &&
      betSlipList[0].translatedName.split(REGEX_VS);
    let betSlipHeader = (
      <div className="collapsible-header bet-slip__header">
        <span className="bet-builder__title bet-slip__header__teams">
          {this.renderTeamName(teamNames[0])}
          <div className="bet-slip__header__team-vs">{teamVS[0]}</div>
          {this.renderTeamName(teamNames[1])}
        </span>
        <div className="bet-slip__header__rhs" />
      </div>
    );
    let content = (
      <div className="bet-drawer__list">
        {betSlipList.map((betSlip, list) => (
          <BetSlip key={betSlip.localId} betSlip={betSlip} />
        ))}
      </div>
    );
    return (
      <div
        className={`bet-slip-container ${
          betslipFull === true ? "betslipfull" : ""
        }`}
      >
        <Collapsible
          header={betSlipHeader}
          content={content}
          isActive={this.props.betSlipList[0].isActive}
          status={"open"}
          onToggle={this.toggleCollapsible}
          withArrows={true}
        />
      </div>
    );
  };

  componentDidMount = () => {
    BetDrawerLogic.updateBetSlipGroupedEvents();
  };

  render() {
    const { betSlipList } = this.props;

    if (betSlipList && betSlipList.length > 0) {
      return (
        <div className="bet-slip">{this.getBetSlipContent(betSlipList)}</div>
      );
    } else {
      return null;
    }
  }
}

const mapDispatchToProps = dispatch => ({
  updateBetSlip: betSlip => dispatch.betSlipListModel.updateBetSlip(betSlip),
  updateCollapsedBetSlipsCount: value =>
    dispatch.betSlipListModel.updateCollapsedBetSlipsCount(value),
  updateBetSlipGroupedEvents: () =>
    dispatch.betSlipListModel.updateBetSlipGroupedEvents(),
  toggleNumberOfBetSlipGroupedEvents: betSlipId =>
    dispatch.betSlipListModel.toggleNumberOfBetSlipGroupedEvents(betSlipId),
});

const mapStateToProps = state => ({
  isIdle: state.sessionModel.isIdle,
  user: state.userModel.user,
  betslipFull: state.betSlipListModel.betslipFull,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetSlipEvent) as any;
